import { Box, Button } from '@betterment/samba-react';

import { trackClick } from '../../../features/track';
import { DateRangeOption } from '../../../graphql/schema';

const descriptionWithPrefix = (description: string) => (prefix: string) => `${prefix} ${description}`;

const dateRangeOptions = [
  {
    label: 'All',
    value: DateRangeOption.AllTime,
    description: 'All time',
    prefixedDescription: descriptionWithPrefix('all time'),
  },
  {
    label: '5Y',
    value: DateRangeOption.PastFiveYears,
    description: 'Past 5 years',
    prefixedDescription: descriptionWithPrefix('past 5 years'),
  },
  {
    label: '3Y',
    value: DateRangeOption.PastThreeYears,
    description: 'Past 3 years',
    prefixedDescription: descriptionWithPrefix('past 3 years'),
  },
  {
    label: '1Y',
    value: DateRangeOption.PastYear,
    description: 'Past year',
    prefixedDescription: descriptionWithPrefix('past year'),
  },
  {
    label: 'YTD',
    value: DateRangeOption.YearToDate,
    description: 'Year to date',
    prefixedDescription: descriptionWithPrefix('year to date'),
  },
  {
    label: '3M',
    value: DateRangeOption.PastThreeMonths,
    description: 'Past 3 months',
    prefixedDescription: descriptionWithPrefix('past 3 months'),
  },
  {
    label: '1M',
    value: DateRangeOption.PastMonth,
    description: 'Past month',
    prefixedDescription: descriptionWithPrefix('past month'),
  },
];

export const dateRangeFilterByValue = (value: DateRangeOption) =>
  dateRangeOptions.find(option => option.value === value);

export const DateRangeFilter: React.FC<{
  onChange: (option: DateRangeOption) => void;
  selected: DateRangeOption;
}> = ({ onChange, selected }) => {
  const handleDateRangeClick = (value: DateRangeOption) => {
    trackClick({
      name: 'timeSeriesInteraction',
      module: 'Performance',
      location: 'DateRangeFilter',
    });
    onChange(value);
  };

  return (
    <Box
      role="radiogroup"
      aria-label="Date range filter"
      css={{ display: 'flex', gap: 'space.100', paddingY: 'space.300', boxShadow: 'xs' }}
    >
      {dateRangeOptions.map(option => (
        <Button
          key={option.value}
          onClick={() => handleDateRangeClick(option.value)}
          variant={selected === option.value ? 'solidPrimary' : 'ghostSecondary'}
          spacing="compact"
          role="radio"
          aria-checked={selected === option.value}
          aria-label={option.description}
          css={{
            minWidth: 'size.500',
            borderRadius: '20px', // pill-shaped buttons
          }}
        >
          {option.label}
        </Button>
      ))}
    </Box>
  );
};
